import {
  clear,
  getActingTenantId,
  getMe,
  isOperator,
  setActingTenantId,
  subscribe,
} from '@yc/api-client'
import { computed, readonly, ref } from 'vue'

const tick = ref(0)

subscribe(() => {
  tick.value += 1
})

export function useSession() {
  const me = computed(() => {
    void tick.value
    return getMe()
  })
  const actingTenantId = computed(() => {
    void tick.value
    return getActingTenantId()
  })
  const operator = computed(() => {
    void tick.value
    return isOperator()
  })

  return {
    me: readonly(me),
    actingTenantId: readonly(actingTenantId),
    operator: readonly(operator),
    setActingTenantId,
    clear,
  }
}